import { formFieldEdit } from '@wix/bi-logger-forms-platform-uou/v2';
import { useBi } from '@wix/form-fields';
import { useRef } from 'react';
export const useReportFieldEdit = form => {
  const lastChangedFields = useRef([]);
  const bi = useBi();
  return changedValues => {
    const changedFieldTargets = Object.keys(changedValues);
    const isEditingDifferentFields = changedFieldTargets.length !== lastChangedFields.current.length || changedFieldTargets.some((target, index) => target !== lastChangedFields.current[index]);
    if (isEditingDifferentFields) {
      lastChangedFields.current = changedFieldTargets;
      changedFieldTargets.forEach(target => {
        var _form$fields, _changedField$view;
        const changedField = form == null || (_form$fields = form.fields) == null ? void 0 : _form$fields.find(field => field.target === target);
        bi.report(formFieldEdit({
          field_id: changedField == null ? void 0 : changedField.id,
          field_label: changedField == null || (_changedField$view = changedField.view) == null ? void 0 : _changedField$view.label,
          field_target: (changedField == null ? void 0 : changedField.target) || undefined
        }));
      });
    }
  };
};
//# sourceMappingURL=use-report-field-edit.js.map